























































































































































































import Vue from 'vue';
import auth from "@/services/auth";
import { ColumnType } from '@/components/apiSearch/models/ApiSearch';
import { FilteringModel } from '@/services/filtering';
import ApiSearchPage from '@/components/apiSearch/components/ApiSearchPage.vue';
import IconButton from "@/components/IconButton.vue";
import KanriInvoiceItemsView from "./KanriInvoiceItemsView.vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import store, { KanriInvoiceStore } from "../services/KanriInvoiceStore";
import { ValidationRules } from '@/models/Validation';
import { rules } from "../models/GenoExperimentalInvoice";
import DateInput from "../../../components/DateInput.vue";
import ApiResponse from '@/models/ApiResponse';
import http, { handleApiResponse } from '@/services/http';
import base64toUInt8Array from '@/services/fileConvert';
import PdfViewer from "@/components/PdfViewer.vue";
import eventBus from '@/services/eventBus';
import configuration from '@/models/Configuration';
import { t } from "@/plugins/i18n";

interface Data {
  url: string;
  filter: FilteringModel;
  store: KanriInvoiceStore;

  isEinvoice: boolean;
  shipDate: string;
  remark: string;
  rules: ValidationRules;
  importInProgress: boolean;
  finalReportSrc: Uint8Array | null;
  columns: any[];
}

interface Methods {
  checkPermission(name: string): boolean;
  showDetails(item: any): void;
  deletingKanri(head: any): void;
  cancelDeletingKanri(head: any): void;
  deleteKanri(head: any): void;
  revokingApproval(head: any): void;
  cancelRevokingApproval(head: any): void;
  revokeApproval(head: any): void;
  importKanri(head: any, isUsedCar?: boolean | null): void;
}

interface Computed {
  valid: boolean;
  isPurchase: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    KanriInvoiceItemsView,
    ApiSearchPage,
    IconButton,
    MoneyDisplay,
    DateInput,
    PdfViewer
  },

  data() {
    return {
      url: `kanri/invoices/${this.$route.name == "KanriInvoicesSale" ? "sale" : "purchase"}`,
      filter: new FilteringModel(),
      store,

      isEinvoice: false,
      shipDate: "",
      remark: "",
      rules,
      importInProgress: false,
      finalReportSrc: null,
      columns: [
        {
          field: "objectId",
          title: t("Kanri_KanriID"),
        },
        {
          field: "invoiceNo",
          title: t("Szamlaszam"),
        },
        {
          field: "partnerName",
          title: t("Partner"),
        },
        {
          field: "typeName",
          title: t("SzamlaTipusa"),
        },
        {
          field: "approvalDate",
          title: t("JovahagyasDatuma"),
          type: ColumnType.Date,
        },
        {
          field: "netto",
          title: t("Netto"),
          cell: "nettoTemplate",
          type: ColumnType.Right,
          filterable: false
        },
        {
          field: "vat",
          title: t("AFA"),
          cell: "vatTemplate",
          type: ColumnType.Right,
          filterable: false
        },
        {
          field: "total",
          title: t("Brutto"),
          cell: "totalTemplate",
          type: ColumnType.Right,
          filterable: false
        },
        {
          field: "procStatus",
          title: t("Kanri_FeldolgozasStatusz"),
        },
        //{
        //  title: "Beemelt számla",
        //  cell: "importedTemplate",
        //  filterable: false
        //},
        {
          filterable: false,
          cell: "importCell"
        },
      ]
    }
  },

  beforeMount() {
    const id = Number(this.$route.params.id);
    if (id > 1) {
      this.url += `/${id}`
    }
  },

  mounted() {
    if (this.$route.name == "KanriInvoicesPurchase") {
      this.columns = this.columns.filter((x) => x.field != "typeName")
    }
  },

  methods: {
    checkPermission(name: string): boolean {
      const menuPerm = auth.menuPermissions.find(x => x.name == name);
      return menuPerm?.isGranted ?? true;
    },

    async showDetails(item: any) {
      this.isEinvoice = false;
      this.shipDate = new Date().toDateString();
      this.remark = "";
      //this.finalReportSrc = null;
      item.isDeleting = false;
      item.isRevoking = false;
      item.selected = !item.selected;

      if (item.genoId > 1) {
        eventBus.$emit("kanriInvoices:reload");
      }
    },

    async deletingKanri(head: any) {
      head.isDeleting = true;
      head.selected = !head.selected;
    },

    async cancelDeletingKanri(head: any) {
      head.isDeleting = false;
      head.selected = false;
    },

    async deleteKanri(head: any) {
      head.isLoading = true;

      try {
        await this.store.deleteKanri(head.objectId)
      }
      finally {
        head.isLoading = false;

        (this.$refs.apiSearch as any).refreshClick();
      }
    },

    // MIKT55: Kanri jóváhagyás kézi visszavonása beragadt bizonylatnál (a TF előjegyzés már törölve,
    // de a Kanri felé a status_code=2 nem ment ki, ezért a Kanri "Törlés" gombja inaktív maradt).
    async revokingApproval(head: any) {
      head.isDeleting = false;
      head.isRevoking = true;
      head.selected = true;
    },

    async cancelRevokingApproval(head: any) {
      head.isRevoking = false;
      head.selected = false;
    },

    async revokeApproval(head: any) {
      head.isLoading = true;

      try {
        await this.store.revokeKanriApproval(head.objectId);
        head.isRevoking = false;
        head.selected = false;
        eventBus.$emit("success", t("Kanri_AKanriJovahagyasVisszavonasaTorlesStatusz"));
        (this.$refs.apiSearch as any).refreshClick();
      }
      finally {
        head.isLoading = false;
      }
    },

    async importKanri(head: any, isUsedCar: boolean | null = null){
      //gj. beszerzés számlánál a beemelés előtt a felhasználónak kell dönteni az új/használt jellegről
      if (head.carPurchase && isUsedCar == null) {
        if (!head.selected) {
          this.showDetails(head);
        }
        return;
      }

      this.importInProgress = true;
      head.isLoading = true;

      if (this.$route.name == "KanriInvoicesPurchase") {
        const success = (await this.store.refreshInvoice(Number(head.objectId), "PURCHASE"));
        if (!success) {
          head.isLoading = false;
          return;
        }
      }
      else if (this.$route.name == "KanriInvoicesSale") {
        const success = (await this.store.refreshInvoice(Number(head.objectId), "SALE"));
        if (!success) {
          head.isLoading = false;
          return;
        }
      }

      //await this.store.downSyncPartner(Number(head.objectId));
      const payload = {
        isEinvoice: this.isEinvoice,
        shipDate: this.shipDate,
        remark: this.remark,
        isUsedCar,
      };
      
      let ret: any = {};
      try {
        ret = (await this.store.importKanri(Number(head.objectId), payload));
      } finally {
        head.isLoading = false;
      }
      
      if (ret && (ret as any).id > 1 && ret.errorList.length == 0) {
        eventBus.$emit("success", t("Kanri_SikeresSzamlaBeemeles"));
        //TOYT100: pl. hiányzó Kanri fizetési tétel miatti alapértelmezett fizetési mód jelzése
        if ((ret as any).warningList?.length) {
          eventBus.$emit("warn", (ret as any).warningList.join("\n"));
        }
        if ((ret as any).isFinalGeno) {
          //eventBus.$emit("success", "Sikeres végszámla generálás!");
          const pict = await http.get<ApiResponse<string>>(`experimental-invoices/report/final-invoice/geno/${(ret as any).proform}/GENO/${true}`).then(handleApiResponse);
          this.finalReportSrc = base64toUInt8Array(pict);
          // head.preGenId = (ret as any).id;
          // head.genoId = (ret as any).proform;
        }
        if ((ret as any).retType == "geno") {
          this.$router.push(`/geno-experimental-invoices/${(ret as any).id}`);
        }
        else if((ret as any).retType == "noto") {
          this.$router.push(`/noto/${(ret as any).id}`);
        }
        else if((ret as any).retType == "geni") {
          if (configuration.invoiceFlow.enabled) {
            this.$router.push(`/general-incoming-invoice/flow/edit/${(ret as any).id}/3`);
          }
          else {
            this.$router.push(`/general-incoming-invoice/edit/${(ret as any).partnerId}/${(ret as any).id}`);
          }
        }
      }
      else {
        eventBus.$error(ret.errorList.join("\n"));
      }
      this.importInProgress = false;
    }
  },

  computed: {
    valid(): boolean {
      if (!this.shipDate) {
        return true;
      }
      return false;
    },

    isPurchase(): boolean {
      return this.$route.name == "KanriInvoicesPurchase";
    }
  },
})
